export const INPUT_BORDER_WIDTH = 1;
export const INPUT_HEIGHT = 46;
export const INPUT_X_AFFORDANCE_MOBILE = 16;
export const INPUT_X_AFFORDANCE_DESKTOP = 24;

export const NON_INPUT_X_AFFORDANCE_MOBILE = INPUT_X_AFFORDANCE_MOBILE + INPUT_BORDER_WIDTH;
export const NON_INPUT_X_AFFORDANCE_DESKTOP = INPUT_X_AFFORDANCE_DESKTOP + INPUT_BORDER_WIDTH;

